import { CouponRecipientListService } from './../../../services/campaign-2.0/coupon-recipient-list.service';
import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { CampaignClusterheadService } from './../../../services/campaign-2.0/campaign-clusterhead.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-new-coupon-recipient-list',
  templateUrl: './new-coupon-recipient-list.component.html',
  styleUrls: ['./new-coupon-recipient-list.component.css', '../coupon-setup.scss']
})
export class NewCouponRecipientListComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  dateFilter = KontableComponent.DateFilter;
  listName: string;
  selectedClusterHeads: string[] = [];
  @Output() onSaveList: EventEmitter<number> = new EventEmitter;

  constructor(
    public clusterHeadService: CampaignClusterheadService,
    private couponRecipientListService: CouponRecipientListService
  ) { }

  ngOnInit() {
  }

  saveList() {
    this.couponRecipientListService.saveRecipientListName({name: this.listName}).subscribe(res => {
      const newRecipientListId = res.id;
      this.couponRecipientListService.saveRecipientListClusterhead({distribution_list_id: res.id, cluster_head_id_array: this.selectedClusterHeads}).subscribe(() => this.onSaveList.emit(newRecipientListId));
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/new-coupon-recipient-list/new-coupon-recipient-list.component.ts